import React from "react";
import { useGLTF } from "@react-three/drei";

export default function Model({ ...props }) {
  const { nodes, materials } = useGLTF("/win95/win95.gltf");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.win95.geometry}
        material={materials.palette}
        rotation={[Math.PI / 2, 0, 0]}
      />
    </group>
  );
}

useGLTF.preload("/win95.gltf");
